export const FIREBASE_INSTANCE = 'FIREBASE_INSTANCE';
export const FIREBASE_STATUS = 'FIREBASE_STATUS';
export const FIREBASE_USER = 'FIREBASE_USER';
export const FIREBASE_LISTENER = 'FIREBASE_LISTENER';
